var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLargeSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 43.75L34.6875 34.6875M39.5833 22.9167C39.5833 32.1214 32.1214 39.5833 22.9167 39.5833C13.7119 39.5833 6.25 32.1214 6.25 22.9167C6.25 13.7119 13.7119 6.25 22.9167 6.25C32.1214 6.25 39.5833 13.7119 39.5833 22.9167Z",
    stroke: "#A1A1A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeSearch);
export default __webpack_public_path__ + "static/media/large-search.f73881af79ae8ab959b7216802e17a11.svg";
export { ForwardRef as ReactComponent };